import { FieldTypes } from "pages/employer-of-record/components/AutoForm";
import { countryIs, field, OPTIONAL, personalInfo, REQUIRED } from "./utils";
import * as NIGERIA from "pages/employer-of-record/onboarding/profile-info/form/ng/constants.ng";

export const nigeriaFields = {
  ngIdentificationType: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "ngIdentificationType",
    label: "Identification Type",
    placeholder: "Select identification type",
    options: NIGERIA.IDENTIFICATION_TYPE_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("NG"),
    },
    value: personalInfo("ngIdentificationType", ""),
  }),
  ngIdentificationNumber: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "ngIdentificationNumber",
    label: "Identification Number",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("NG"),
    },
    value: personalInfo("ngIdentificationNumber", ""),
  }),
  ngHasPen: field({
    type: FieldTypes.boolean,
    informationType: "identification",
    name: "ngHasPen",
    label: "Do you have a Pension Identification Number (PEN)?",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("NG"),
    },
    value: personalInfo("ngHasPen", false),
  }),
  ngPenNumber: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "ngPenNumber",
    label: "PEN Number",
    validations: {
      required: {
        when: {
          ngHasPen: (value) => value === true,
        },
      },
    },
    hideWhen: {
      ngHasPen: (value) => value === false,
    },
    scenarios: {
      onboarding: countryIs("NG"),
    },
    value: personalInfo("ngPenNumber", ""),
  }),
  ngPensionFundAdministrator: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "ngPensionFundAdministrator",
    label: "Pension Fund Administrator",
    validations: {
      required: {
        when: {
          ngHasPen: (value) => value === true,
        },
      },
    },
    hideWhen: {
      ngHasPen: (value) => value === false,
    },
    scenarios: {
      onboarding: countryIs("NG"),
    },
    value: personalInfo("ngPensionFundAdministrator", ""),
  }),
  ngPensionCustodianBankName: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "ngPensionCustodianBankName",
    label: "Pension Custodian Bank Name",
    validations: OPTIONAL,
    hideWhen: {
      ngHasPen: (value) => value === false,
    },
    scenarios: {
      onboarding: countryIs("NG"),
    },
    value: personalInfo("ngPensionCustodianBankName", ""),
  }),
  ngPensionCustodianBankAccountNo: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "ngPensionCustodianBankAccountNo",
    label: "Pension Custodian Bank Account Number",
    validations: OPTIONAL,
    hideWhen: {
      ngHasPen: (value) => value === false,
    },
    scenarios: {
      onboarding: countryIs("NG"),
    },
    value: personalInfo("ngPensionCustodianBankAccountNo", ""),
  }),
  ngWillContributeNhf: field({
    type: FieldTypes.boolean,
    informationType: "identification",
    name: "ngWillContributeNhf",
    label: "Will you contribute to the National Health Insurance (NHF)?",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("NG"),
    },
    value: personalInfo("ngWillContributeNhf", false),
  }),
  ngNhfNumber: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "ngNhfNumber",
    label: "NHF Number",
    validations: OPTIONAL,
    scenarios: {
      onboarding: countryIs("NG"),
    },
    value: personalInfo("ngNhfNumber", ""),
  }),
  ngAnnualRentPaid: field({
    type: FieldTypes.number,
    informationType: "identification",
    name: "ngAnnualRentPaid",
    label: "Annual Rent Paid",
    validations: OPTIONAL,
    scenarios: {
      onboarding: countryIs("NG"),
    },
    value: personalInfo("ngAnnualRentPaid", ""),
  }),
  ngAnnualPremiumPayment: field({
    type: FieldTypes.number,
    informationType: "identification",
    name: "ngAnnualPremiumPayment",
    label: "Annual Premium Payment",
    validations: OPTIONAL,
    scenarios: {
      onboarding: countryIs("NG"),
    },
    value: personalInfo("ngAnnualPremiumPayment", ""),
  }),
  ngMaritalStatus: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "ngMaritalStatus",
    label: "Marital Status",
    placeholder: "Select marital status",
    options: NIGERIA.MARITAL_STATUS_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("NG"),
    },
    value: personalInfo("ngMaritalStatus", ""),
  }),
  ngGender: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "ngGender",
    label: "Gender",
    placeholder: "Select gender",
    options: NIGERIA.GENDER_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("NG"),
    },
    value: personalInfo("ngGender", ""),
  }),
};
